import React, { useEffect, useState } from 'react';
import Modal from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';
import Image from '../../components/Image';
import './SetupProfileSteps.scss';
import steps from '../../global/texts/setupSteps';

type Props = {
    showSetupProfileModal?: boolean;
    onHide?: any;
    ios?: boolean;
    android?: boolean;
};

const SetupProfileSteps = (props: Props) => {
    const [showSetupProfileModal, setShowSetupProfileModal] = useState<boolean>(true);
    const [stepCount, setStepCount] = useState<number>(1);
    const [stepImgCount, setStepImgCount] = useState<number>(0);
    const [sliceStartCount, setSliceStartCount] = useState<number>(0);
    const [sliceEndCount, setSliceEndCount] = useState<number>(4);

    useEffect(() => {
        if (window.matchMedia('(max-width: 600px)').matches) {
            setSliceEndCount(2);
        }
    }, []);

    const handlePrevSteps = () => {
        setStepImgCount(stepImgCount - 1);

        if (stepImgCount === 1 || stepImgCount === 6) return;
        if (window.matchMedia('(max-width: 600px)').matches) {
            if (stepCount === 3 || stepCount === 5) {
                setSliceStartCount(sliceStartCount - 2);
                setSliceEndCount(sliceEndCount - 2);
            } else if (stepCount === 7) {
                setSliceStartCount(4);
                setSliceEndCount(6);
            }
        } else {
            if (stepCount < 6) {
                setSliceStartCount(0);
                setSliceEndCount(4);
            }
        }
        setStepCount(stepCount - 1);
    };

    const handleNextSteps = () => {
        if (stepCount >= (props.ios && steps.ios.length ? steps.ios.length : steps.android.length)) {
            setShowSetupProfileModal(false);
            props.onHide();
            return;
        }

        setStepImgCount(stepImgCount + 1);

        if (window.matchMedia('(max-width: 600px)').matches) {
            if (stepCount === 2 || stepCount === 4) {
                setSliceStartCount(sliceStartCount + 2);
                setSliceEndCount(sliceEndCount + 2);
            } else if (stepCount === 6) {
                setSliceStartCount(5);
                setSliceEndCount(7);
            }
        } else {
            if (stepCount > 3) {
                setSliceStartCount(3);
                setSliceEndCount(7);
            }
        }
        if (!stepImgCount || stepImgCount === 5) return;
        setStepCount(stepCount + 1);
    };

    return (
        <div>
            <Modal
                isShowModal={showSetupProfileModal}
                onCloseModal={props.onHide}
                showClose={true}
                className="SetupProfileModal"
            >
                <div className="modalContainer">
                    <div className="d-flex align-items-center imgContainerWeb">
                        <Image
                            className="web"
                            width="100%"
                            height="350px"
                            src={props.ios ? steps.ios_images[stepImgCount] : steps.android_images[stepImgCount]}
                            alt="illustration"
                        />
                    </div>
                    <div>
                        <div className="profileTitle">Downloading your profile is easy!</div>
                        <div className="greenLine"></div>
                        <br />
                        <div className="d-sm-flex align-items-center d-md-none my-2 imgContainerMWeb">
                            <Image
                                className="mweb"
                                width="100%"
                                height="175px"
                                src={
                                    props.ios
                                        ? steps.ios_images_mweb[stepImgCount]
                                        : steps.android_images_mweb[stepImgCount]
                                }
                                alt="illustration"
                            />
                        </div>
                        <div className="stepsCard">
                            {steps[props.ios ? 'ios' : 'android']
                                .slice(sliceStartCount, sliceEndCount)
                                .map((data: any, index: any) => {
                                    return (
                                        <div key={index} className="stepsContainer">
                                            {stepCount === data.step && <div className="greenLineVertical"></div>}
                                            <div className="stepsText">
                                                <div
                                                    className={`stepsTitle ${
                                                        stepCount === data.step ? 'selectedTitle' : 'unSelectedTitle'
                                                    }`}
                                                >
                                                    <span className="stepNum">{data.step}</span>
                                                    {data.title}
                                                </div>
                                                <div
                                                    className={`stepsDesc ${
                                                        stepCount === data.step ? 'selectedDesc' : 'unSelectedDesc'
                                                    }`}
                                                >
                                                    {data.desc} <br />
                                                    {data.desc_newline}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                        <div className="d-flex justify-content-between">
                            <div className="selectPlanAndProceedBtn">
                                <Button
                                    className="selectPlanAndProceed prevBtn"
                                    primary={true}
                                    onClick={handlePrevSteps}
                                    disabled={!stepImgCount ? true : false}
                                >
                                    Previous
                                </Button>
                            </div>
                            <div className="selectPlanAndProceedBtn">
                                <Button
                                    className="selectPlanAndProceed nextBtn"
                                    primary={false}
                                    onClick={handleNextSteps}
                                >
                                    {stepCount >=
                                    (props.ios && steps.ios.length ? steps.ios.length : steps.android.length)
                                        ? 'Done'
                                        : 'Next'}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default SetupProfileSteps;
